import { observer } from 'mobx-react';
import React from 'react';
import { allOptionsValue, PAYMENT_TYPES, paymentTypesLangKeys } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import CustomSelect from 'src/view/components/Controls/Pickers/CustomSelect/CustomSelect';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import SpinLoader from 'src/view/components/Controls/SpinLoader/SpinLoader';
import { ReportsBranchPicker } from 'src/view/screens/ReportsScreen/components/ReportsBranchPicker/ReportsBranchPicker';
import ReportsCalendar from 'src/view/screens/ReportsScreen/components/ReportsCalendar/ReportsCalendar';
import ReportsFranchiseePicker from 'src/view/screens/ReportsScreen/components/ReportsFranchiseePicker/ReportsFranchiseePicker';
import { defaultDetailsReportFilters } from 'src/view/screens/ReportsScreen/constants/reprots';
import ReportContent from 'src/view/screens/ReportsScreen/containers/ReportContent/ReportContent';
import ReportHeader from 'src/view/screens/ReportsScreen/containers/ReportHeader/ReportHeader';
import { salesDetailsStore } from 'src/view/screens/ReportsScreen/screens/SalesDetails/store/salesDetailsStore';
import { IPaymentMethodsParams } from 'src/view/screens/ReportsScreen/screens/SalesDetails/types/salesDetails';
import { reportsStore } from 'src/view/screens/ReportsScreen/store/reportsStore';
import { appStore } from '~/mobx/appStore';

@observer
export default class PaymentMethodSales extends React.Component<{}, {}> {
  onSelectPaymentMethod = (options: IPickerOption[]) => {
    salesDetailsStore.setFilters({
      paymentMethods: options,
    });
  };

  async componentDidMount() {
    if (!salesDetailsStore.reports.paymentMethods.data) await this.buildReport();
  }

  get paymentMethodOptions() {
    return [
      { label: localeStore.t('all_methods'), value: allOptionsValue },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.CASH]), value: PAYMENT_TYPES.CASH },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.ONLINE_PAYMENT]), value: PAYMENT_TYPES.ONLINE_PAYMENT },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.TERMINAL]), value: PAYMENT_TYPES.TERMINAL },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.JAHEZ]), value: PAYMENT_TYPES.JAHEZ },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.CAREEM]), value: PAYMENT_TYPES.CAREEM },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.DOOK_CASH]), value: PAYMENT_TYPES.DOOK_CASH },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.DOOK_ONLINE_PAYMENT]), value: PAYMENT_TYPES.DOOK_ONLINE_PAYMENT },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.HUNGER_STATION]), value: PAYMENT_TYPES.HUNGER_STATION },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.TO_YOU]), value: PAYMENT_TYPES.TO_YOU },
      { label: localeStore.t(paymentTypesLangKeys[PAYMENT_TYPES.KEETA]), value: PAYMENT_TYPES.KEETA },
    ];
  }

  buildReport = async () => {
    await salesDetailsStore.fetchPaymentMethodsReport();
  };

  onExportReport = async () => {
    const params: IPaymentMethodsParams = {
      ...reportsStore.getReportBuildParams(),
      payment_methods: salesDetailsStore.filters.paymentMethods.some((option) => option.value === allOptionsValue)
        ? []
        : salesDetailsStore.filters.paymentMethods.map((option) => option.value as PAYMENT_TYPES),
    };
    await salesDetailsStore.exportDetailsReportToXls(params, 'paymentMethods', 'payment-methods', 'Payment methods sales');
  };

  onCancel = () => {
    if (salesDetailsStore.cancelReportBuild.paymentMethods) salesDetailsStore.cancelReportBuild.paymentMethods('Cancelled');
  };

  render() {
    return (
      <div className="d-flex flex-column full-width flex-grow-1 mt-4">
        <ReportHeader
          onGenerateReport={this.buildReport}
          onExportReport={this.onExportReport}
          exportLoader={salesDetailsStore.reports.paymentMethods.loading}
        >
          <ReportsCalendar startDate={reportsStore.filters.startDate} endDate={reportsStore.filters.endDate} />
          <CustomSelect
            className="mr-2"
            inputClassName="report-header__picker"
            onSelect={this.onSelectPaymentMethod}
            options={this.paymentMethodOptions}
            optionsDesc="methods"
            emptyListText={localeStore.t('no_results_found')}
            isMulti
            isSearchable
            selectedOptions={salesDetailsStore.filters.paymentMethods}
            defaultOptions={defaultDetailsReportFilters.paymentMethods}
          />
          {appStore.isAddonsAvailable.franchise ? <ReportsFranchiseePicker /> : <ReportsBranchPicker />}
        </ReportHeader>
        <ReportContent actualReport={salesDetailsStore.reports.paymentMethods.data} reportColumnName="payment_method" />
        {salesDetailsStore.reports.paymentMethods.loading ? <SpinLoader onCancel={this.onCancel} /> : null}
      </div>
    );
  }
}
